<div class="container" style="
padding-bottom: 10%;" *ngIf="hidecard == false">
    <div class="row">
        <div class="col-lg-4" style="    padding-top: 15px;" (click)="yourOrders()">
            <div class="card card2">
                <div class="card-body">
                    <div class="row">
                        <div class="col-4"
                            style="margin-right: 2%;float: left;min-height: 1px;overflow: visible;  text-align: center;">
                            <!-- <img style="width: 80px;
                            height: 80px;"
                                src="https://m.media-amazon.com/images/G/31/x-locale/cs/ya/images/Box._CB485927553_.png"
                                alt=""> -->
                            <i style="width: 80px;
                            height: 70px;        font-size: 70px; color: #ff4c3b;" class="fa fa-archive"
                                aria-hidden="true"></i>
                        </div>
                        <div class="col-7">
                            <h2 style="font-size: 20px;">Your Orders</h2>

                            <span>Track, return, or buy things again</span>
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <div class="col-lg-4" style="    padding-top: 15px;" (click)="yourAddress()">
            <div class="card card2">
                <div class="card-body">
                    <div class="row">
                        <div class="col-4"
                            style="margin-right: 2%;float: left;min-height: 1px;overflow: visible;  text-align: center;">
                            <!-- <img style="width: 80px;
                            height: 80px;"
                                src="https://m.media-amazon.com/images/G/31/x-locale/cs/ya/images/address-map-pin._CB485934183_.png"
                                alt=""> -->
                            <i style="width: 80px;
                            height: 70px;font-size: 70px;color: #ff4c3b; " class="fa fa-map-marker"
                                aria-hidden="true"></i>
                        </div>
                        <div class="col-7">
                            <h2 style="font-size: 20px;">Your Addresses</h2>

                            <span>Edit addresses for orders</span>
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <div class="col-lg-4" style="    padding-top: 15px;" (click)="Contact()">
            <div class="card card2">
                <div class="card-body">
                    <div class="row">
                        <div class="col-4"
                            style="margin-right: 2%;float: left;min-height: 1px;overflow: visible;  text-align: center;">
                            <!-- <img style="width: 80px;
                            height: 80px;"
                                src="https://m.media-amazon.com/images/G/31/x-locale/cs/help/images/gateway/self-service/contact_us._CB623781998_.png"
                                alt=""> -->

                            <i style="width: 80px;
                            height: 70px;        font-size: 70px; color: #ff4c3b; " class="fa fa-headphones"
                                aria-hidden="true"></i>
                        </div>
                        <div class="col-7">
                            <h2 style="font-size: 20px;">Contact Us</h2>

                            <!-- <span>Edit addresses for orders</span> -->
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <div class="col-lg-4" style="padding-top: 15px;" (click)="yourwishlist()">
            <div class="card card2">
                <div class="card-body">
                    <div class="row">
                        <div class="col-4"
                            style="margin-right: 2%;float: left;min-height: 1px;overflow: visible;text-align: center;">
                            <!-- <img style="width: 80px;
                            height: 80px;"
                                src="https://as2.ftcdn.net/v2/jpg/07/43/46/69/1000_F_743466913_L1UF39XRnPbNDB2z5Pt7rh2DY12ZxNJq.jpg"
                                alt=""> -->
                            <i style="width: 80px;
                            height: 70px;        font-size: 70px; color: #ff4c3b; " class="fa fa-heart"
                                aria-hidden="true"></i>
                        </div>
                        <div class="col-7">
                            <h2 style="font-size: 20px;">Wish List</h2>

                            <!-- <span>Edit addresses for orders</span> -->
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <div class="col-lg-4" style="padding-top: 15px;" (click)="storeList()">
            <div class="card card2">
                <div class="card-body">
                    <div class="row">
                        <div class="col-4"
                            style="margin-right: 2%;float: left;min-height: 1px;overflow: visible;text-align: center;">
                            <!-- <img style="width: 80px;
                            height: 80px;"
                                src="https://cdn1.vectorstock.com/i/1000x1000/25/50/store-icon-vector-13652550.jpg"
                                alt=""> -->
                            <i style="width: 80px;
                            height: 70px;        font-size: 70px;  color: #ff4c3b;" class="fa fa-building"
                                aria-hidden="true"></i>
                        </div>
                        <div class="col-7">
                            <h2 style="font-size: 20px;">Shop List</h2>

                            <!-- <span>Edit addresses for orders</span> -->
                        </div>
                    </div>

                </div>

            </div>
        </div>


        <div class="col-lg-4" style="padding-top: 15px;" (click)="couponLIst()">
            <div class="card card2">
                <div class="card-body">
                    <div class="row">
                        <div class="col-4"
                            style="margin-right: 2%;float: left;min-height: 1px;overflow: visible;text-align: center;">
                            <!-- <img style="width: 80px;
                            height: 80px;"
                                src="https://cdn1.vectorstock.com/i/1000x1000/25/50/store-icon-vector-13652550.jpg"
                                alt=""> -->

                            <i class="fa fa-gift" style="width: 80px;height: 70px;font-size: 70px;  color: #ff4c3b;"
                                aria-hidden="true"></i>
                        </div>
                        <div class="col-7">
                            <h2 style="font-size: 20px;">Rewards</h2>

                            <!-- <span>Edit addresses for orders</span> -->
                        </div>
                    </div>

                </div>

            </div>
            <div style="padding: 25px;"></div>
        </div>

        <!-- <div class="col-lg-4" style="padding-top: 15px;padding-bottom: 30px;" (click)="logout()">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-4" style="margin-right: 2%;float: left;min-height: 1px;overflow: visible;">
                            <img style="width: 80px;
                            height: 80px;"
                                src="https://m.media-amazon.com/images/G/31/x-locale/cs/ya/images/sign-in-lock._CB485931504_.png"
                                alt="">
                        </div>
                        <div class="col-7">
                            <h2 style="font-size: 20px;">Login & Security</h2>

                            <span>Edit Login,name,and mobile number</span>
                        </div>
                    </div>

                </div>

            </div>
        </div> -->

    </div>

</div>

<div class="container">
    <div class="checkout-page" *ngIf="hidecard == true">
        <div class="checkout-form">

            <div class="row">
                <div class="col-lg-3 col-sm-12 col-xs-12"></div>
                <div class="col-lg-8 col-sm-12 col-xs-12">

                    <div class="checkout-details" style="margin-bottom: 20px;">

                        <div class="order-box">
                            <div class="col-md-12 row">
                                <div class="col-md-6">
                                    <div class="checkout-title">
                                        <h3>Contact Us</h3>
                                    </div>
                                </div>
                                <div class="col-md-6">

                                </div>
                            </div>
                            <div class="row check-out">

                                <div class="form-group col-md-6 col-sm-6 col-xs-12">

                                    <div class="field-label">Name <span class="text-danger">*</span></div>
                                    <input type="text" name="name" [(ngModel)]="Enquiry.name" value="name"
                                        placeholder="Enter Name" autocomplete="off" maxlength="25"
                                        [formControl]="checkoutForm.controls['name']"
                                        (keypress)="validateAlphabeticInput($event)">

                                    <div *ngIf="checkoutForm.controls.name.touched && checkoutForm.controls.name.errors?.required"
                                        class="text text-danger">
                                        Name is required.
                                    </div>

                                </div>

                                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                    <div class="field-label">Phone No <span class="text-danger">*</span>
                                    </div>
                                    <input type="text" name="phone" [formControl]="checkoutForm.controls['phone']"
                                        value="phone" [(ngModel)]="Enquiry.phone" placeholder="Enter PhoneNumber"
                                        autocomplete="off" maxlength="10" (keypress)="validateNumericInput($event)">
                                    <div *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.required"
                                        class="text text-danger">
                                        Phone No is required.
                                    </div>
                                    <div *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.pattern"
                                        class="text text-danger">
                                        Phone No is must be number.
                                    </div>

                                </div>



                                <div class="form-group col-md-12 col-sm-6 col-xs-12">
                                    <div class="field-label">Enquiry</div>
                                    <!-- <textarea type="text" name="state" value="state" 
                                        autocomplete="off" maxlength="50"> -->
                                    <textarea type="text" name="state" style="height: 80%;    padding: 10px;"
                                        value="state" [formControl]="checkoutForm.controls['enquiry']"
                                        [(ngModel)]="Enquiry.enquiry" autocomplete="off" minlength="10"></textarea>
                                </div>
                                <div *ngIf="checkoutForm.controls.enquiry.touched && checkoutForm.controls.enquiry.errors?.required"
                                    class="text text-danger">
                                    Enquiry is required
                                </div>
                                <div *ngIf="checkoutForm.controls.enquiry.touched && checkoutForm.controls.enquiry.errors?.maxlength"
                                    class="text text-danger">
                                    Maximum 50 character
                                </div>





                            </div>
                            <div class="text-end col-md-12 col-sm-12 col-xs-12">

                                <div class="row">
                                    <div class="col-lg-4">
                                        <input class="ml-5 " style="float: inline-start;" type="file"
                                            (change)="handleFileInput($event.target.files)" />

                                    </div>
                                    <div class="col-lg-8" style="    margin-top: 20px;
">
                                        <button type="submit" class="btn-solid btn" style="    margin-right: 25px;"
                                            [disabled]="!checkoutForm.valid" (click)="saveEnquiry()">
                                            Save
                                        </button>
                                        <button type="submit" class="btn-solid btn" (click)="backcard()">
                                            Back
                                        </button>

                                    </div>


                                </div>

                                <!-- <img id="Image" class="ml-5" style="border: 0px solid white;border-radius: 17px; 
                                      background-color: #f3f3f3; height: 274px; width: 251px;" [src]="imageUrl" width="325"><br> -->








                            </div>
                        </div>
                    </div>
                </div>



            </div>

        </div>
    </div>
</div>



<ng-template #fileWarning let-modal>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="modal-body">
                    <h4 class="modal-title w-100" style="    text-align: center;
                    margin-top: 20px;">Upload File</h4>

                    <p style="text-align: center;
                    margin-top: 10px;">Your File Limit Exist (upload below 10 MB) </p>

                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-theme btn-sm" data-dismiss="modal"
                        (click)="modal.dismiss('Cross click')">Cancel</button>

                </div>
            </div>
        </div>
    </div>
</ng-template>